<template>
  <div id="app">
    <router-view></router-view> <!-- 这里是动态渲染的组件 -->
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.trackTrafficSource();
  },
  methods: {
    trackTrafficSource() {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('from');

      if (source && typeof window.gtag !== 'undefined') {
        // 发送自定义事件
        window.gtag('event', 'traffic_source', {
          'source': source
        });

        // 存储来源，用于后续转化归因
        sessionStorage.setItem('traffic_source', source);

        console.log('Traffic source tracked:', source);
      }
    }
  }
}
</script>

<style>
/* 全局样式优化 */
#app {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1a202c;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

/* 添加Inter字体 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

/* 全局滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>
